var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { StyledImg } from "./image.styles";
export function Image(_a) {
    var { fallbackSrc, fallbackBackgroundColor } = _a, imgProps = __rest(_a, ["fallbackSrc", "fallbackBackgroundColor"]);
    const [isFallbackSrc, setIsFallbackSrc] = useState(!imgProps.src);
    return (
    // todo check ts error
    // @ts-ignore
    _jsx(StyledImg, Object.assign({ isFallbackSrc: isFallbackSrc, fallbackBackgroundColor: fallbackBackgroundColor, onError: (event) => {
            const self = event.target;
            if (fallbackSrc) {
                setIsFallbackSrc(true);
                self.onerror = null;
                self.setAttribute("src", fallbackSrc);
                if (fallbackBackgroundColor) {
                    self.style.backgroundColor = fallbackBackgroundColor;
                }
            }
        }, alt: imgProps.alt, src: imgProps.src || fallbackSrc }, imgProps)));
}
